import breakpointChecker from "../utils/breakpointChecker"
export default () => {
  (function($) {
    $(document).ready(function() {
      $('.search:not(.search--mobile)').height(0).hide()
      $('.misc__link--search').on('click', function() {
        let height = $('.search:not(.search--mobile)').height() <= 0 ? 140 : 0
        $('.search:not(.search--mobile)').height(height).css('display', 'flex')
        $('.misc__link--search').toggleClass('opened')
        if ($('.misc__link--search').is('.opened')) {
          $('.header').css('position', 'relative')
          $('#search').focus()
        } else {
          $('.header').attr('style', '')
        }
      })

      $('[name="search"]').on('input', function() {
        if ($(this).val()) {
          $(this).siblings('.search--reset').show()
        } else {
          $(this).siblings('.search--reset').hide()
        }
      })
      
      $('.search--reset').on('click', function() {
        $(this).hide()
      })

      $(window).on('scroll', function() {
        if ($('.misc__link--search').is('.opened')) {
          $('.misc__link--search').trigger('click')
        }
      })

      const BPchecker = new breakpointChecker({
        mediaQuery: '(min-width:992px)',
        onMatch: function() {
          $('body').removeClass('enabledFullPanel')
          $('body, .header__main').attr('style', '')
          $('.header__main').removeClass('header__main--noGradiant')
          if ($('.mobileNav__item--search').is('.opened')) {
            $('.search--toggle').trigger('click')
          }
          $('.search--reset').trigger('click')
        },
        onDifferent: function() {
          if ($('.misc__link--search').is('.opened')) {
            $('.misc__link--search').trigger('click')
          }
          $('.search--reset').trigger('click')
        }
      })
    })

    const headerStyle = function() {
      if ($(window).scrollTop() > 70) {
        $('.header__main').addClass('header__main--noGradiant')
      } else {
        $('.header__main').removeClass('header__main--noGradiant')
      }
    }

    $(document).ready(function() {
      $('.search--mobile').hide()
      $('.mobileNav__item--search').on('click', function() {
        $('.search--mobile').toggle()
        $('.mobileNav__item--search').addClass('opened')
        $('.mobileNav__item--hamburger .hamburger').addClass('is-active')
        if ($('.mobileNav__item--search').is('.opened')) {
          $('.search--mobile').attr('aria-hidden', false)
          $('body').css('overflow', 'hidden').addClass('enabledFullPanel')
          $('.header__main').css({
            background: '#fffdf9'
          })
          $('.header__main').addClass('header__main--noGradiant')
          $('#searchMobile').focus()
        } else {
          $('.search--mobile').attr('aria-hidden', true)
          $('body').removeClass('enabledFullPanel')
          $('body, .header__main').attr('style', '')
          headerStyle()
        }
      })
      // $('.search--toggle').on('click', function() {
      //   $('.search--mobile').hide()
      //   $('body').removeClass('enabledFullPanel')
      //   $('body, .header__main').attr('style', '')
      //   $('.mobileNav__item--search').removeClass('opened')
      //   $('.header__main').attr('style', '')
      //   headerStyle()
      // })
    })
  })(window.hsvmJQuery)

}
